/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AddressFieldsQueryVariables = {};
export type AddressFieldsQueryResponse = {
    readonly deliveryTypes: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly deliveryTypeId: number;
                readonly name: string;
            };
        }> | null;
    } | null;
};
export type AddressFieldsQuery = {
    readonly response: AddressFieldsQueryResponse;
    readonly variables: AddressFieldsQueryVariables;
};



/*
query AddressFieldsQuery {
  deliveryTypes {
    edges {
      node {
        deliveryTypeId
        name
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deliveryTypeId",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "AddressFieldsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DeliveryTypeConnection",
                    "kind": "LinkedField",
                    "name": "deliveryTypes",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DeliveryTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "DeliveryType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v1 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "AddressFieldsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DeliveryTypeConnection",
                    "kind": "LinkedField",
                    "name": "deliveryTypes",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "DeliveryTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "DeliveryType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v1 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "76525d6b7d046690a8e786b628e38c0f",
            "id": null,
            "metadata": {},
            "name": "AddressFieldsQuery",
            "operationKind": "query",
            "text": "query AddressFieldsQuery {\n  deliveryTypes {\n    edges {\n      node {\n        deliveryTypeId\n        name\n        id\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '9b800211f5d27e4f82858e3a5e18d30d';
export default node;
